/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2hvbWUva3NtYWkvd2ViZGV2L2FkbWluLXRlbXBsYXRlL3NyYy9hcHAvc2hhcmVkL2Zvcm0teC1lZGl0YWJsZS9mb3JtLXgtZWRpdGFibGUuY29tcG9uZW50LnNjc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vaG9tZS9rc21haS93ZWJkZXYvYWRtaW4tdGVtcGxhdGUvc3JjL2FwcC9zaGFyZWQvZm9ybS14LWVkaXRhYmxlL2Zvcm0teC1lZGl0YWJsZS5jb21wb25lbnQuc2NzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// ./$$_gendir/src/app/shared/form-x-editable/form-x-editable.component.scss.shim.ngstyle.ts